import './waardebepaling.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function initWaardebepaling() {
	const root = document.querySelector( '[data-component="waardebepaling"]' );

	if ( ! root ) {
		return;
	}

	const paths = root.querySelectorAll( '.b-waardebepaling__highlight svg path' );

	if ( ! paths.length ) {
		return;
	}

	const triggers = [];

	paths.forEach( ( path ) => {
		const length = path.getTotalLength();

		gsap.set( path, { strokeDasharray: length, strokeDashoffset: length } );

		const tween = gsap.to( path, {
			strokeDashoffset: 0,
			duration: 1.5,
			ease: 'power2.out',
			scrollTrigger: {
				trigger: root,
				start: 'top 70%',
				toggleActions: 'play none none reverse',
			},
		} );

		triggers.push( tween.scrollTrigger );
	} );

	root._waardebepalingCleanup = () => {
		triggers.forEach( ( st ) => {
			if ( st ) {
				st.kill();
			}
		} );
	};
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initWaardebepaling );
} else {
	initWaardebepaling();
}
